import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row mt-2" }
const _hoisted_2 = { class: "col-12" }
const _hoisted_3 = { class: "card card-xl-stretch mb-8 d-flex flex-column" }
const _hoisted_4 = { class: "card-body" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-column align-items-start" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "card-label fw-bolder fs-3 mb-1" }, "Filters"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-muted mt-1 fw-bold fs-7" }, "Filter statistics")
], -1)
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col-12 col-md-6 mb-2 mb-md-0" }
const _hoisted_8 = { class: "col-12 col-md-6" }
const _hoisted_9 = { class: "col-12 mt-2" }
const _hoisted_10 = { class: "col-12" }
const _hoisted_11 = { class: "row" }
const _hoisted_12 = { class: "col-12 col-md-6" }
const _hoisted_13 = { class: "col-12 col-md-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ClientDropdown = _resolveComponent("ClientDropdown")!
  const _component_BranchesDropdown = _resolveComponent("BranchesDropdown")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_JobsByWorkerPieChart = _resolveComponent("JobsByWorkerPieChart")!
  const _component_ReportedHoursByWorker = _resolveComponent("ReportedHoursByWorker")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_ClientDropdown, {
                modelValue: _ctx.filter.client,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filter.client) = $event))
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_BranchesDropdown, {
                modelValue: _ctx.filter.branch,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filter.branch) = $event))
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_component_el_date_picker, {
                type: "daterange",
                "range-separator": "To",
                class: "",
                modelValue: _ctx.filter.date,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.filter.date) = $event)),
                size: "large",
                format: "DD/MM/YYYY",
                "value-format": "DD/MM/YYYY",
                "start-placeholder": "Start date",
                "end-placeholder": "End date"
              }, null, 8, ["modelValue"])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _createVNode(_component_JobsByWorkerPieChart, { filters: _ctx.filter }, null, 8, ["filters"])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createVNode(_component_ReportedHoursByWorker, { filters: _ctx.filter }, null, 8, ["filters"])
        ])
      ])
    ])
  ]))
}